import fetch from "auth/FetchMasterInterceptor";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "constants/AuthConstant";
const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;
const masterService = {};

masterService.editbankdetail = function (data) {
  return fetch({
    url: "/employee/bank-details/add-update",
    method: "post",
    data: data,
  });
};

masterService.getbankdetail = function (data) {
  return fetch({
    url: "/employee/bank-details/list",
    method: "post",
    data: data,
  });
};

masterService.getTicket = function (data) {
  return fetch({
    url: "/ticket/list",
    method: "post",
    data: data,
  });
};

masterService.addTicket = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/ticket/add`, data, config);
};

masterService.deleteTicket = function (data) {
  return fetch({
    url: "/ticket/delete",
    method: "post",
    data: data,
  });
};

masterService.getDepartment = function (data) {
  return fetch({
    url: "/department/list",
    method: "post",
    data: data,
  });
};

masterService.addDepartment = function (data) {
  return fetch({
    url: "/department/add",
    method: "post",
    data: data,
  });
};

masterService.editDepartment = function (data) {
  return fetch({
    url: "/department/update",
    method: "post",
    data: data,
  });
};

masterService.deleteDepartment = function (data) {
  return fetch({
    url: "/department/delete",
    method: "post",
    data: data,
  });
};

masterService.getDesignation = function (data) {
  return fetch({
    url: "/designation/list",
    method: "post",
    data: data,
  });
};

masterService.addDesignation = function (data) {
  return fetch({
    url: "/designation/add",
    method: "post",
    data: data,
  });
};

masterService.editDesignation = function (data) {
  return fetch({
    url: "/designation/update",
    method: "post",
    data: data,
  });
};

masterService.deleteDesignation = function (data) {
  return fetch({
    url: "/designation/delete",
    method: "post",
    data: data,
  });
};

masterService.getOffice = function (data) {
  return fetch({
    url: "/office/list",
    method: "post",
    data: data,
  });
};

masterService.addOffice = function (data) {
  return fetch({
    url: "/office/add",
    method: "post",
    data: data,
  });
};

masterService.editOffice = function (data) {
  return fetch({
    url: "/office/update",
    method: "post",
    data: data,
  });
};

masterService.deleteOffice = function (data) {
  return fetch({
    url: "/office/delete",
    method: "post",
    data: data,
  });
};

masterService.showOffice = function (data) {
  return fetch({
    url: "/office/show",
    method: "post",
    data: data,
  });
};

masterService.getTask = function (data) {
  return fetch({
    url: "/createtask/list",
    method: "post",
    data: data,
  });
};

masterService.assignTask = function (data) {
  return fetch({
    url: "/createtask/assignTask",
    method: "post",
    data: data,
  });
};

masterService.getleave = function (data) {
  return fetch({
    url: "/leave/list",
    method: "post",
    data: data,
  });
};
masterService.editLeave = function (data) {
  return fetch({
    url: "/leave/update",
    method: "post",
    data: data,
  });
};
masterService.addLeave = function (data) {
  return fetch({
    url: "/leave/create",
    method: "post",
    data: data,
  });
};
masterService.deleteleave = function (data) {
  return fetch({
    url: "/leave/delete",
    method: "post",
    data: data,
  });
};

masterService.getearningstatement = function (data) {
  return fetch({
    url: "/type-valuation/list",
    method: "post",
    data: data,
  });
};

masterService.getHoliday = function (data) {
  return fetch({
    url: "/holiday/list",
    method: "post",
    data: data,
  });
};
masterService.addHoliday = function (data) {
  return fetch({
    url: "/holiday/create",
    method: "post",
    data: data,
  });
};
masterService.editHoliday = function (data) {
  return fetch({
    url: "/holiday/update",
    method: "post",
    data: data,
  });
};
masterService.deleteHoliday = function (data) {
  return fetch({
    url: "/holiday/delete",
    method: "post",
    data: data,
  });
};
masterService.addTask = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/createtask/add`, data, config);
};

masterService.editTask = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/createtask/update`, data, config);
};

masterService.deleteTask = function (data) {
  return fetch({
    url: "/createtask/delete",
    method: "post",
    data: data,
  });
};

masterService.getRole = function (data) {
  return fetch({
    url: "/role/list",
    method: "post",
    data: data,
  });
};

masterService.addRole = function (data) {
  return fetch({
    url: "/role/add",
    method: "post",
    data: data,
  });
};

masterService.editRole = function (data) {
  return fetch({
    url: "/role/update",
    method: "post",
    data: data,
  });
};

masterService.deleteRole = function (data) {
  return fetch({
    url: "/role/delete",
    method: "post",
    data: data,
  });
};

masterService.assignPermission = function (data) {
  return fetch({
    url: "/rolepermission/update",
    method: "post",
    data: data,
  });
};

masterService.getPermission = function (data) {
  return fetch({
    url: "/permission/list",
    method: "post",
    data: data,
  });
};

masterService.getTarget = function (data) {
  return fetch({
    url: "/target/list",
    method: "post",
    data: data,
  });
};

masterService.getEmployee = function (data) {
  return fetch({
    url: "/employee/list",
    method: "post",
    data: data,
  });
};

masterService.addEmployee = function (data) {
  return fetch({
    url: "/employee/create",
    method: "post",
    data: data,
  });
};

masterService.editEmployee = function (data) {
  return fetch({
    url: "/employee/update",
    method: "post",
    data: data,
  });
};

masterService.deleteEmployee = function (data) {
  return fetch({
    url: "/employee/delete",
    method: "post",
    data: data,
  });
};

masterService.showEmployee = function (data) {
  return fetch({
    url: "/employee/show",
    method: "post",
    data: data,
  });
};

masterService.getOfficetype = function (data) {
  return fetch({
    url: "/officetype/list",
    method: "post",
    data: data,
  });
};

masterService.addOfficetype = function (data) {
  return fetch({
    url: "/officetype/add",
    method: "post",
    data: data,
  });
};

masterService.editOfficetype = function (data) {
  return fetch({
    url: "/officetype/update",
    method: "post",
    data: data,
  });
};

masterService.deleteOfficetype = function (data) {
  return fetch({
    url: "/officetype/delete",
    method: "post",
    data: data,
  });
};

masterService.getDesign = function (data) {
  return fetch({
    url: "/design/list",
    method: "post",
    data: data,
  });
};

masterService.getViewDesignProduct = function (data) {
  return fetch({
    url: "/design/show",
    method: "post",
    data: data,
  });
};

masterService.addDesign = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/design/add`, data, config);
};

masterService.editDesign = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/design/update`, data, config);
};

masterService.deleteDesign = function (data) {
  return fetch({
    url: "/design/delete",
    method: "post",
    data: data,
  });
};

masterService.getCategory = function (data) {
  return fetch({
    url: "/category/list",
    method: "post",
    data: data,
  });
};

masterService.addCategory = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/category/add`, data, config);
};

masterService.editCategory = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/category/update`, data, config);
};

masterService.deleteCategory = function (data) {
  return fetch({
    url: "/category/delete",
    method: "post",
    data: data,
  });
};

masterService.getExpense = function (data) {
  return fetch({
    url: "/expense/list",
    method: "post",
    data: data,
  });
};

masterService.addExpense = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/expense/add`, data, config);
};

masterService.editExpense = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/expense/update`, data, config);
};

masterService.deleteExpense = function (data) {
  return fetch({
    url: "/expense/delete",
    method: "post",
    data: data,
  });
};

masterService.getDiscount = function (data) {
  return fetch({
    url: "/discountauthoritie/list",
    method: "post",
    data: data,
  });
};

masterService.addDiscount = function (data) {
  return fetch({
    url: "/discountauthoritie/add",
    method: "post",
    data: data,
  });
};

masterService.editDiscount = function (data) {
  return fetch({
    url: "/discountauthoritie/update",
    method: "post",
    data: data,
  });
};

masterService.deleteDiscount = function (data) {
  return fetch({
    url: "/discountauthoritie/delete",
    method: "post",
    data: data,
  });
};

masterService.getOrderProp = function (data) {
  return fetch({
    url: "/orderprobability/list",
    method: "post",
    data: data,
  });
};
masterService.addOrderProp = function (data) {
  return fetch({
    url: "/orderprobability/add",
    method: "post",
    data: data,
  });
};

masterService.editOrderProp = function (data) {
  return fetch({
    url: "/orderprobability/update",
    method: "post",
    data: data,
  });
};
masterService.deleteOrderProp = function (data) {
  return fetch({
    url: "/orderprobability/delete",
    method: "post",
    data: data,
  });
};

masterService.getKpi = function (data) {
  return fetch({
    url: "kpi/list",
    method: "post",
    data: data,
  });
};
masterService.addSKpi = function (data) {
  return fetch({
    url: "kpi/add",
    method: "post",
    data: data,
  });
};

masterService.addAproval = function (data) {
  return fetch({
    url: "/saleskpi/approve/reject",
    method: "post",
    data: data,
  });
};

masterService.editKpi = function (data) {
  return fetch({
    url: "/kpi/update",
    method: "post",
    data: data,
  });
};

masterService.deleteKpi = function (data) {
  return fetch({
    url: "/kpi/delete",
    method: "post",
    data: data,
  });
};

masterService.getSaleskpi = function (data) {
  return fetch({
    url: "saleskpi/list",
    method: "post",
    data: data,
  });
};
masterService.addSalesKpi = function (data) {
  return fetch({
    url: "saleskpi/add",
    method: "post",
    data: data,
  });
};

masterService.addAproval = function (data) {
  return fetch({
    url: "saleskpi/approve/reject",
    method: "post",
    data: data,
  });
};

masterService.editSalesKpi = function (data) {
  return fetch({
    url: "saleskpi/update",
    method: "post",
    data: data,
  });
};

masterService.deleteSalesKpi = function (data) {
  return fetch({
    url: "saleskpi/delete",
    method: "post",
    data: data,
  });
};

masterService.getCustomer = function (data) {
  return fetch({
    url: "/customer/list",
    method: "post",
    data: data,
  });
};
masterService.addCustomer = function (data) {
  return fetch({
    url: "/customer/add",
    method: "post",
    data: data,
  });
};
masterService.editCustomer = function (data) {
  return fetch({
    url: "/customer/update",
    method: "post",
    data: data,
  });
};

masterService.showCustomer = function (data) {
  return fetch({
    url: "/customer/show",
    method: "post",
    data: data,
  });
};

masterService.deleteCustomer = function (data) {
  return fetch({
    url: "/customer/delete",
    method: "post",
    data: data,
  });
};

masterService.getSize = function (data) {
  return fetch({
    url: "/size/list",
    method: "post",
    data: data,
  });
};

masterService.addSize = function (data) {
  return fetch({
    url: "/size/add",
    method: "post",
    data: data,
  });
};

masterService.editSize = function (data) {
  return fetch({
    url: "/size/update",
    method: "post",
    data: data,
  });
};

masterService.deleteSize = function (data) {
  return fetch({
    url: "/size/delete",
    method: "post",
    data: data,
  });
};

masterService.getProduct = function (data) {
  return fetch({
    url: "/product/list",
    method: "post",
    data: data,
  });
};

masterService.addProduct = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/product/add`, data, config);
};

masterService.updateProduct = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/product/update`, data, config);
};

masterService.deleteProduct = function (data) {
  return fetch({
    url: "/pricing/delete",
    method: "post",
    data: data,
  });
};

masterService.getPricing = function (data) {
  return fetch({
    url: "/pricing/list",
    method: "post",
    data: data,
  });
};

masterService.getViewPricing = function (data) {
  return fetch({
    url: "/pricing/show",
    method: "post",
    data: data,
  });
};

masterService.addPricing = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/pricing/add`, data, config);
};

masterService.editPricing = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/pricing/update`, data, config);
};

masterService.deletePricing = function (data) {
  return fetch({
    url: "/pricing/delete",
    method: "post",
    data: data,
  });
};

masterService.getUser = function (data) {
  return fetch({
    url: "/user/list",
    method: "post",
    data: data,
  });
};

masterService.addUser = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/user/add`, data, config);
};

masterService.editUser = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/user/update`, data, config);
};

masterService.deleteUser = function (data) {
  return fetch({
    url: "/user/delete",
    method: "post",
    data: data,
  });
};

masterService.getStanderdmailer = function (data) {
  return fetch({
    url: "/standerdmailer/list",
    method: "post",
    data: data,
  });
};

masterService.addStanderdmailer = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/standerdmailer/add`, data, config);
};

masterService.editStanderdmailer = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/standerdmailer/update`, data, config);
};

masterService.deleteStanderdmailer = function (data) {
  return fetch({
    url: "/standerdmailer/delete",
    method: "post",
    data: data,
  });
};

masterService.getVisitscheduling = function (data) {
  return fetch({
    url: "/visitscheduling/list",
    method: "post",
    data: data,
  });
};

masterService.addVisitscheduling = function (data) {
  return fetch({
    url: "/visitscheduling/add",
    method: "post",
    data: data,
  });
};

masterService.editVisitscheduling = function (data) {
  return fetch({
    url: "/visitscheduling/update",
    method: "post",
    data: data,
  });
};

masterService.deleteVisitscheduling = function (data) {
  return fetch({
    url: "/visitscheduling/delete",
    method: "post",
    data: data,
  });
};

masterService.getProductlead = function (data) {
  return fetch({
    url: "/productlead/list",
    method: "post",
    data: data,
  });
};

masterService.addProductlead = function (data) {
  return fetch({
    url: "/productlead/add",
    method: "post",
    data: data,
  });
};

masterService.editProductlead = function (data) {
  return fetch({
    url: "/productlead/update",
    method: "post",
    data: data,
  });
};

masterService.deleteProductlead = function (data) {
  return fetch({
    url: "/productlead/delete",
    method: "post",
    data: data,
  });
};

masterService.getProductLeadDetails = function (data) {
  return fetch({
    url: "/editproduct/list",
    method: "post",
    data: data,
  });
};

masterService.getLeadcreation = function (data) {
  return fetch({
    url: "/leadcreation/list",
    method: "post",
    data: data,
  });
};

masterService.getLeadcreationDetails = function (data) {
  return fetch({
    url: "/editlead/list",
    method: "post",
    data: data,
  });
};

masterService.addLeadcreation = function (data) {
  return fetch({
    url: "/leadcreation/add",
    method: "post",
    data: data,
  });
};

masterService.editLeadcreation = function (data) {
  return fetch({
    url: "/leadcreation/update",
    method: "post",
    data: data,
  });
};

masterService.deleteLeadcreation = function (data) {
  return fetch({
    url: "/leadcreation/delete",
    method: "post",
    data: data,
  });
};

masterService.getDelivery = function (data) {
  return fetch({
    url: "/delivery/list",
    method: "post",
    data: data,
  });
};

masterService.addDelivery = function (data) {
  return fetch({
    url: "/delivery/add",
    method: "post",
    data: data,
  });
};

masterService.editDelivery = function (data) {
  return fetch({
    url: "/delivery/update",
    method: "post",
    data: data,
  });
};

masterService.deleteDelivery = function (data) {
  return fetch({
    url: "/delivery/delete",
    method: "post",
    data: data,
  });
};

masterService.getPayment = function (data) {
  return fetch({
    url: "/payment/list",
    method: "post",
    data: data,
  });
};

masterService.addPayment = function (data) {
  return fetch({
    url: "/payment/add",
    method: "post",
    data: data,
  });
};

masterService.editPayment = function (data) {
  return fetch({
    url: "/payment/edit",
    method: "post",
    data: data,
  });
};

masterService.deletePayment = function (data) {
  return fetch({
    url: "/payment/delete",
    method: "post",
    data: data,
  });
};

masterService.getMom = function (data) {
  return fetch({
    url: "/mom/list",
    method: "post",
    data: data,
  });
};

masterService.deleteMom = function (data) {
  return fetch({
    url: "/mom/delete",
    method: "post",
    data: data,
  });
};

masterService.editMom = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/mom/update`, data, config);
};

masterService.addMom = function (data) {
  const config = {
    headers: {
      "content-type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return axios.post(`${API_BASE_URL}/mom/add`, data, config);
};

masterService.getOffercreation = function (data) {
  return fetch({
    url: "/offercreation/list",
    method: "post",
    data: data,
  });
};

masterService.addOffercreation = function (data) {
  return fetch({
    url: "/offercreation/add",
    method: "post",
    data: data,
  });
};

masterService.editOffercreation = function (data) {
  return fetch({
    url: "/offercreation/update",
    method: "post",
    data: data,
  });
};

masterService.deleteOffercreation = function (data) {
  return fetch({
    url: "/offercreation/delete",
    method: "post",
    data: data,
  });
};

masterService.deleteOfferProduct = function (data) {
  return fetch({
    url: "/productoffer/delete",
    method: "post",
    data: data,
  });
};

masterService.addSaleskpi = function (data) {
  return fetch({
    url: "/saleskpi/add",
    method: "post",
    data: data,
  });
};

masterService.editSaleskpi = function (data) {
  return fetch({
    url: "/saleskpi/update",
    method: "post",
    data: data,
  });
};

masterService.getearningstatement = function (data) {
  return fetch({
    url: "/type-valuation/list",
    method: "post",
    data: data,
  });
};
masterService.showearningstatement = function (data) {
  return fetch({
    url: "/type-rate/show",
    method: "post",
    data: data,
  });
};

// Working Days Services
masterService.getWorkingDays = function (data) {
  return fetch({
    url: "/workingday/list",
    method: "post",
    data: data || {},
  });
};

masterService.updateWorkingDays = function (data) {
  return fetch({
    url: "/workingday/add",
    method: "post",
    data: data,
  });
};
masterService.addearningstatement = function (data) {
  return fetch({
    url: "/type-valuation/create",
    method: "post",
    data: data,
  });
};
masterService.editearningstatement = function (data) {
  return fetch({
    url: "/type-valuation/update",
    method: "post",
    data: data,
  });
};
masterService.deleteearningstatement = function (data) {
  return fetch({
    url: "/type-valuation/delete",
    method: "post",
    data: data,
  });
};

masterService.getShift = function (data) {
  return fetch({
    url: "/shift/list",
    method: "post",
    data: data,
  });
};

masterService.addShift = function (data) {
  return fetch({
    url: "/shift/add",
    method: "post",
    data: data,
  });
};

masterService.editShift = function (data) {
  return fetch({
    url: "/shift/update",
    method: "post",
    data: data,
  });
};

masterService.deleteShift = function (data) {
  return fetch({
    url: "/shift/delete",
    method: "post",
    data: data,
  });
};

export default masterService;
